import {
  FETCH_SCAMS_REQUEST,
  FETCH_SCAMS_SUCCESS,
  FETCH_SCAMS_FAILURE,
  SUBMIT_SCAM_SUCCESS,
  SUBMIT_PRESCAM,
  REMOVE_SCAM,
  LIKE_SCAM,
  DISLIKE_SCAM,
  NEUTRAL_SCAM,
  INC_COMMENT_COUNT,
} from "./scamActions"; // Adjust the path if needed

const initialState = {
  loading: false,
  myScamAlertPost: [],
  error: null,
  preScamData: null
};

const scamReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_SCAMS_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case FETCH_SCAMS_SUCCESS:
      return {
        ...state,
        loading: false,
        // Ensure myScamAlertPost is always an array
        myScamAlertPost: Array.isArray(action.payload) ? action.payload : [],
        error: null,
      };

    case FETCH_SCAMS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case SUBMIT_SCAM_SUCCESS:
      return {
        ...state,
        // Safeguard that myScamAlertPost is an array before adding a new scam
        myScamAlertPost: Array.isArray(state.myScamAlertPost)
          ? [...state.myScamAlertPost, action.payload]
          : [action.payload], // If it's not an array, start fresh with an array
        // Set preScamData to null after successful scam submission
        preScamData: null,
      };

    case SUBMIT_PRESCAM:
      return {
        ...state,
        preScamData: action.payload, // Handling pre-scam data submission
      };


      case REMOVE_SCAM:
        return {
          ...state,
          myScamAlertPost: Array.isArray(state.myScamAlertPost)
            ? state.myScamAlertPost.filter((scam) => scam.scamPK !== action.payload)
            : state.myScamAlertPost, // If not an array, don't change the state
        };
      
    case LIKE_SCAM:
    case DISLIKE_SCAM:
    case NEUTRAL_SCAM:
      return {
        ...state,
        myScamAlertPost: state.myScamAlertPost.map((scam) => {
          if (scam.scamPK === action.payload.scamId) {
            let updatedScam = { ...scam };

            // If the current reaction is 'like', remove it
            if (scam.reaction_type === 1) updatedScam.total_likes = Math.max(0, updatedScam.total_likes - 1); // Prevent negative likes

            // If the current reaction is 'dislike', remove it
            if (scam.reaction_type === 2) updatedScam.total_dislikes = Math.max(0, updatedScam.total_dislikes - 1); // Prevent negative dislikes

            // If the new reaction is 'like'
            if (action.payload.reaction_type === 1) {
              updatedScam.total_likes += 1; // Add a new like

              // If the user previously disliked, remove that dislike
              if (scam.isLoggedInUserDisliked === 1) {
                updatedScam.total_dislikes = Math.max(0, updatedScam.total_dislikes - 1); // Prevent negative dislikes
              }

              updatedScam.isLoggedInUserLiked = 1; // Set isLoggedInUserLiked to 1
              updatedScam.isLoggedInUserDisliked = 0; // Set isLoggedInUserDisliked to 0
            }

            // If the new reaction is 'dislike'
            if (action.payload.reaction_type === 2) {
              updatedScam.total_dislikes += 1; // Add a new dislike

              // If the user previously liked, remove that like
              if (scam.isLoggedInUserLiked === 1) {
                updatedScam.total_likes = Math.max(0, updatedScam.total_likes - 1); // Prevent negative likes
              }

              updatedScam.isLoggedInUserLiked = 0; // Set isLoggedInUserLiked to 0
              updatedScam.isLoggedInUserDisliked = 1; // Set isLoggedInUserDisliked to 1
            }

            // If the new reaction is 'neutral' (reset both)
            if (action.payload.reaction_type === 0) {
              // Neutral reaction (reset both)
              if (scam.isLoggedInUserLiked === 1) {
                updatedScam.total_likes = Math.max(0, updatedScam.total_likes - 1); // Prevent negative likes
              }
              if (scam.isLoggedInUserDisliked === 1) {
                updatedScam.total_dislikes = Math.max(0, updatedScam.total_dislikes - 1); // Prevent negative dislikes
              }

              updatedScam.isLoggedInUserLiked = 0;
              updatedScam.isLoggedInUserDisliked = 0;
            }

            // Update the reaction type
            updatedScam.reaction_type = action.payload.reaction_type;
            return updatedScam;
          }

          return scam;
        }),
      };
    case INC_COMMENT_COUNT:
      return {
        ...state,
        myScamAlertPost: state.myScamAlertPost.map((scam) => {
          if (scam.scamPK == action.payload) {
            return { ...scam, count_comment: (scam.count_comment || 0) + 1 };
          }
          return scam;
        }),
      };


    default:
      return state;
  }
};


export default scamReducer;
